export default __webpack_public_path__ + "static/media/ad-section-holder.0e90c24b.svg";